module.exports = __webpack_public_path__ + "img/hcms.2cb7605c.svg";